import { Form, Formik } from 'formik';

import FormField from '../FormField';
import { IField } from '../interfaces/IField';
import { promptSchema } from './schema/prompt.schema';

import Button from '@/components/ui/button';
import { ICreatePromptPayload } from '@/interfaces/api/prompt/ICreatePromptPayload';

const values: ICreatePromptPayload = {
	text: '',
	title: '',
	isDefault: 'No',
};

const DEFAULT_CREATE_OR_UPDATE_EXPLAIN =
	'If a new Prompt is created or updated with the option to set it as the default, it will replace any previously set default prompt.';

const DEFAULT_EXPLAIN =
	'The default prompt is the one that the system uses by default.';

export enum PromptOptions {
	VIEW = 'VIEW',
	CREATE = 'CREATE',
	UPDATE = 'UPDATE',
}
type PropTypes = {
	handleSubmit: (values: ICreatePromptPayload) => Promise<void> | undefined;
	loading: boolean;
	promptOption: PromptOptions;
	initialValues?: ICreatePromptPayload;
};

const PromptForm = ({
	handleSubmit,
	loading,
	promptOption,
	initialValues = values,
}: PropTypes) => {
	const formFields: IField[] = [
		{
			name: 'title',
			label: 'Prompt Title',
			type: 'text',
			placeholder: 'Monday Prompt',
		},
		{
			name: 'text',
			label: 'Text',
			type: 'textarea',
			placeholder: 'My prompt',
			rows: 5,
		},
		{
			name: 'isDefault',
			label: 'Make this prompt default?',
			type: 'radio',
			options: ['Yes', 'No'],
		},
	];

	const handleInitialValues = (
		initialValues: ICreatePromptPayload,
	): ICreatePromptPayload => {
		return {
			text: initialValues.text,
			title: initialValues.title,
			isDefault: initialValues.isDefault === 'Yes' ? 'Yes' : 'No',
		};
	};

	const handleFormFields = (formFields: IField[]) => {
		if (promptOption === PromptOptions.VIEW) {
			formFields.forEach((field) => (field.disabled = true));
			return formFields;
		}
		return formFields;
	};

	const handleSubmitType = (values: ICreatePromptPayload) => {
		if (promptOption === PromptOptions.VIEW) return;

		return handleSubmit(values);
	};

	return (
		<div className="flex flex-col w-full">
			<h3
				className="font-bold text-xl uppercase text-center"
				data-test="prompt-title"
			>
				{promptOption === PromptOptions.UPDATE
					? 'Update Prompt'
					: promptOption === PromptOptions.CREATE
					? 'Create new prompt'
					: 'View Prompt'}
			</h3>
			<Formik
				initialValues={handleInitialValues(initialValues)}
				onSubmit={(values) => handleSubmitType(values)}
				validationSchema={promptSchema}
			>
				<Form className="w-full">
					{handleFormFields(formFields).map((field) => (
						<FormField key={field.name} {...field} />
					))}

					<div className="border" />
					<div className="my-2">
						<p className="text-left text-xs leading-5 font-normal text-grey-50">
							{DEFAULT_CREATE_OR_UPDATE_EXPLAIN}
						</p>

						<p className="text-left text-xs leading-5 font-normal text-grey-50">
							{DEFAULT_EXPLAIN}
						</p>
					</div>

					{promptOption !== PromptOptions.VIEW && (
						<Button
							type="submit"
							className="w-full my-2"
							shape="rounded"
							isLoading={loading}
							disabled={loading}
							data-test="submit-prompt-button"
						>
							Submit
						</Button>
					)}
				</Form>
			</Formik>
		</div>
	);
};

export default PromptForm;
